import { AnyAction, isAnyOf, ListenerMiddlewareInstance, ThunkDispatch } from '@reduxjs/toolkit'
import { connectorSlice } from '@redux/slices/connectorSlice'
import { clearLocalCustomerContextState } from '@utils/localCustomerContext'
import { clearLocalAppEventState } from '@utils/localAppEventState'

type ListenerInstance = ListenerMiddlewareInstance<unknown, ThunkDispatch<unknown, unknown, AnyAction>, unknown>

/**
 * Cleanup local customer context and event state
 */
export const initLocalCustomerContextStateListener = (listenerMiddleware: ListenerInstance) => {
  listenerMiddleware.startListening({
    matcher: isAnyOf(connectorSlice.actions.sessionExpired, connectorSlice.actions.connectorLogoutInProgress),

    effect: () => {
      clearLocalAppEventState()
      clearLocalCustomerContextState()
    },
  })
}
